import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ForecastingVariantSchema = z.object({
  id: productIdFormat.schema,
  productFamilyId: productFamilyIdFormat.schema,
  title: z.string(),
  sku: z.string(),
  image: z.string().nullish(),
});
export type ForecastingVariant = z.infer<typeof ForecastingVariantSchema>;

export const getForecastingVariants = {
  name: "getForecastingVariants" as const,
  input: z.object({
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(200),
    offset: z.number().int().min(0).optional(),
    search: z.string().optional(),
    skus: z.array(z.string().min(1)).max(200).optional(),
    sortBy: createEnum(["title", "sku"]).optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
  }),
  output: z.object({
    variants: z.array(ForecastingVariantSchema),
    totalCount: z.number().int(),
  }),
};
